// Parses a Castlevania: Belmont's Curse BuildSave_N.sav file into a shape that's easier to render.
//
// The save is JSON written by Unity. Two quirks to undo:
//  - Dictionaries are stored as parallel lists: { m_keys: [...], m_values: [...] }.
//  - Some dictionary values are JSON objects stored as strings.

function toObject(dict, parseValues = false) {
  const out = {}
  if (!dict || !dict.m_keys) return out
  dict.m_keys.forEach((key, i) => {
    const value = dict.m_values[i]
    out[key] = parseValues && typeof value === "string" ? parseJson(value) : value
  })
  return out
}

function parseJson(text) {
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

export function parseSave(text) {
  let raw
  try {
    raw = JSON.parse(text)
  } catch {
    throw new Error("This file isn't a readable save. Saves are named BuildSave_0.sav, BuildSave_1.sav and so on.")
  }
  if (raw.ints && raw.floats) {
    throw new Error("That's PLAYERPREFS.sav, which only holds settings. Choose a BuildSave_N.sav file instead.")
  }
  if (!raw.playerSave) {
    throw new Error("This file doesn't look like a Belmont's Curse save (no player data found).")
  }

  const player = raw.playerSave
  const worlds = toObject(raw.worldSaves)
  for (const world of Object.values(worlds)) {
    world.entities = toObject(world.savableEntityStates, true)
  }
  // Saved state of every in-world object (chest opened, lever pulled, ...), keyed by object GUID.
  const entityStates = {}
  for (const world of Object.values(worlds)) Object.assign(entityStates, world.entities)
  const board = toObject(raw.progressionBoardSave && raw.progressionBoardSave.progressionBoardItemsStates)

  return {
    version: raw.version,
    raw,
    player,
    worlds,
    entityStates,
    rooms: toObject(player.worldRoomExplorationStates, true),
    arcanaSteps: toObject(player.characterProgressionSteps),
    progressionKeys: new Set(player.progressionPersistentSave || []),
    arcanaTaskStates: toObject(player.arcanaTaskStates, true),
    boardUnlocked: Object.values(board).filter((v) => v === "True").length,
    boardTotal: Object.keys(board).length,
  }
}

/** Map item variants (e.g. WeaponSpearTier3_Doppelganger) to the base item they duplicate. */
export function resolveItemAliases(player, gameData) {
  const alias = (id) => (gameData.itemAliases && gameData.itemAliases[id]) || id
  player.itemsInInventory = [...new Set((player.itemsInInventory || []).map(alias))]
  player.equippedWeaponItem = alias(player.equippedWeaponItem)
}
